import { AfterViewInit, Component, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { I18N_CONFIG } from '@conf';
import {
  AswCommonStoreService,
  AswContextStoreService,
  ErrorsHandlerService,
  PageLoadingService,
  SystemDateService,
} from '@lib/services';
import { Observable, Subscription, take } from 'rxjs';
import { SampleSubHeaderComponent } from './sub-header/sample-sub-header/sample-sub-header.component';
import { environment } from '@env/environment';
import { DOCUMENT } from '@angular/common';
import { AswMasterService } from '@lib/services';
import { LOAD_MASTER_LIST } from '@conf';
import { lastValueFrom } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { ServiceRequestPaymentInputSubHeaderComponent } from './sub-header/service-request-payment-input-sub-header/service-request-payment-input-sub-header.component';
import { BookingListSubHeaderComponent } from './sub-header/booking-list/booking-list-sub-header.component';
import { MyBookingSubHeaderComponent } from './sub-header/my-booking/my-booking-sub-header.component';
import { ServicingFunctionIdType, ServicingPageIdType } from '@common/interfaces';
import { YamatoBaggageGuidanceSubHeaderComponent } from './sub-header/yamato-baggage-guidance-sub-header/yamato-baggage-guidance-sub-header.component';
import { EMDSearchSubHeaderComponent } from './sub-header/emd-search-sub-header/emd-search-sub-header.component';
import { DutyFreePreorderGuidanceSubHeaderComponent } from './sub-header/duty-free-preorder-guidance-sub-header/duty-free-preorder-guidance-sub-header.component';
import { ETicketEmdSelectSubHeaderComponent } from './sub-header/e-ticket-emd-select-sub-header/e-ticket-emd-select-sub-header.component';
import { AnaBizStatementOfChargesSelectSubHeaderComponent } from './sub-header/ana-biz-statement-of-charges-select-sub-header/ana-biz-statement-of-charges-select-sub-header.component';
import { ReceiptSearchSubHeaderComponent } from './sub-header/receipt-search-sub-header/receipt-search-sub-header.component';
import { ReservationBasicInformationInputSubHeaderComponent } from './sub-header/reservation-basic-information-input-sub-header/reservation-basic-information-input-sub-header.component';
import { ReceiptSelectSubHeaderComponent } from './sub-header/receipt-select-sub-header/receipt-select-sub-header.component';
import { ServiceRequestCompletedSubHeaderComponent } from './sub-header/service-request-completed/service-request-completed-sub-header.component';
import { BookingSearchSubHeaderComponent } from './sub-header/booking-search/booking-search-sub-header.component';
import { AnaBizApplicationListSubHeaderComponent } from './sub-header/ana-biz-application-list-sub-header/ana-biz-application-list-sub-header.component';
import { PetEasyTravelRequestSubHeaderComponent } from './sub-header/pet-easy-travel-request-sub-header/pet-easy-travel-request-sub-header.component';
import { MyCarValetRequestSubHeaderComponent } from './sub-header/my-car-valet-request-sub-header/my-car-valet-request-sub-header.component';
import { ServicingSeatmapSubHeaderComponent } from './sub-header/servicing-seatmap-sub-header/servicing-seatmap-sub-header.component';
import { JuniorPilotRequestSubHeaderComponent } from './sub-header/junior-pilot-request-sub-header/junior-pilot-request-sub-header.component';
import { InformativeSeatmapSubHeaderComponent } from './sub-header/informative-seatmap-sub-header/informative-seatmap-sub-header.component';
import { SeatAttributeRequestSubHeaderComponent } from './sub-header/seat-attribute-request-sub-header';
import { BoardingCertificateSearchSubHeaderComponent } from './sub-header/boarding-certificate-search-sub-header/boarding-certificate-search-sub-header.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'asw-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  /**
   * ローディング画面表示制御 - 表示モード
   */
  public isPromotion$!: Observable<boolean>;
  /**
   * ローディング画面表示制御 - プロモーションモード判定フラグ
   */
  public isLoading$!: Observable<boolean>;

  constructor(
    private _aswCommonStoreService: AswCommonStoreService,
    private _aswContextStoreSvc: AswContextStoreService,
    private _errorHandlerSvc: ErrorsHandlerService,
    private _systemDateSvc: SystemDateService,
    private _loadingSvc: PageLoadingService,
    private _aswMasterService: AswMasterService,
    private _translateSvc: TranslateService,
    private router: Router,
    @Inject(NgZone) private _ngZone: NgZone,
    @Inject(DOCUMENT) private _document: Document
  ) {
    // ローディング画面の表示モードがプロモーションモードかの判定結果を取得
    this.isPromotion$ = this._loadingSvc.getIsPromotionMode$();
    // ローディング画面のローディング状態取得
    this.isLoading$ = this._loadingSvc.getPageLoadingState$();
  }

  // 言語（変更前の比較用）
  private lang = '';

  ngOnInit(): void {
    // エラーハンドリングServiceの初期化
    this._errorHandlerSvc.init();

    // システム日付Serviceの初期化
    this._systemDateSvc.init();

    //サブヘッダーを指定
    this.subPageSubscription = this._aswCommonStoreService.getPagefuncId$('page').subscribe((data) => {
      const funcPageId = (data.functionId ? data.functionId : '') + '-' + (data.pageId ? data.pageId : '');
      switch (funcPageId) {
        case ServicingFunctionIdType.BOOKING_CONFIRMATION + '-' + ServicingPageIdType.BOOKING_LIST:
          this.subHeader = BookingListSubHeaderComponent;
          break;
        case ServicingFunctionIdType.BOOKING_CONFIRMATION + '-' + ServicingPageIdType.MY_BOOKING:
          this.subHeader = MyBookingSubHeaderComponent;
          break;
        case ServicingFunctionIdType.BOOKING_CONFIRMATION + '-' + ServicingPageIdType.MYBOOKING_ITINERARY:
          this.subHeader = MyBookingSubHeaderComponent;
          break;
        case ServicingFunctionIdType.BOOKING_CONFIRMATION + '-' + ServicingPageIdType.MYBOOKING_PASSENGER:
          this.subHeader = MyBookingSubHeaderComponent;
          break;
        case ServicingFunctionIdType.BOOKING_CONFIRMATION + '-' + ServicingPageIdType.MYBOOKING_SERVICE:
          this.subHeader = MyBookingSubHeaderComponent;
          break;
        case ServicingFunctionIdType.SERVICE_REQUEST + '-' + ServicingPageIdType.SERVICE_REQUEST_PAYMENT_INPUT:
          this.subHeader = ServiceRequestPaymentInputSubHeaderComponent;
          break;
        case ServicingFunctionIdType.REDIRECT_GUIDE + '-' + ServicingPageIdType.YAMATO_BAGGAGE_GUIDANCE:
          this.subHeader = YamatoBaggageGuidanceSubHeaderComponent;
          break;
        case ServicingFunctionIdType.DOCUMENT_DISPLAY + '-' + ServicingPageIdType.EMD_SEARCH:
          this.subHeader = EMDSearchSubHeaderComponent;
          break;
        case ServicingFunctionIdType.DOCUMENT_DISPLAY + '-' + ServicingPageIdType.RECEIPT_SELECT:
          this.subHeader = ReceiptSelectSubHeaderComponent;
          break;
        case ServicingFunctionIdType.REDIRECT_GUIDE + '-' + ServicingPageIdType.DUTY_FREE_PREORDER_GUIDANCE:
          this.subHeader = DutyFreePreorderGuidanceSubHeaderComponent;
          break;
        case ServicingFunctionIdType.DOCUMENT_DISPLAY + '-' + ServicingPageIdType.EMD_SELECT:
          this.subHeader = ETicketEmdSelectSubHeaderComponent;
          break;
        case ServicingFunctionIdType.DOCUMENT_DISPLAY + '-' + ServicingPageIdType.ANABIZ_USAGE_STATEMENT_SELECT:
          this.subHeader = AnaBizStatementOfChargesSelectSubHeaderComponent;
          break;
        case ServicingFunctionIdType.DOCUMENT_DISPLAY + '-' + ServicingPageIdType.RECEIPT_SEARCH:
          this.subHeader = ReceiptSearchSubHeaderComponent;
          break;
        case ServicingFunctionIdType.SERVICE_REQUEST + '-' + ServicingPageIdType.MY_BOOKING:
          this.subHeader = ServiceRequestCompletedSubHeaderComponent;
          break;
        case ServicingFunctionIdType.RESERVATION_BASIC_INFORMATION +
          '-' +
          ServicingPageIdType.RESERVATION_BASIC_INFORMATION_INPUT:
          this.subHeader = ReservationBasicInformationInputSubHeaderComponent;
          break;
        case ServicingFunctionIdType.DOCUMENT_DISPLAY + '-' + ServicingPageIdType.BOARDING_CERTIFICATE_SEARCH:
          this.subHeader = BoardingCertificateSearchSubHeaderComponent;
          break;
        case ServicingFunctionIdType.BOOKING_CONFIRMATION + '-' + ServicingPageIdType.BOOKING_SEARCH:
          this.subHeader = BookingSearchSubHeaderComponent;
          break;
        /** KMS追加start */
        case ServicingFunctionIdType.BOOKING_CONFIRMATION + '-' + ServicingPageIdType.ANA_BIZ_APPLICATION_LIST:
          /** S01-P021：ANA Biz 発券申請一覧 */
          this.subHeader = AnaBizApplicationListSubHeaderComponent;
          break;
        case ServicingFunctionIdType.SERVICE_REQUEST + '-' + ServicingPageIdType.MY_CAR_VALET_REQUEST:
          /** S02-P011：マイカーバレー申込 */
          this.subHeader = MyCarValetRequestSubHeaderComponent;
          break;
        case ServicingFunctionIdType.SERVICE_REQUEST + '-' + ServicingPageIdType.PET_EASY_TRAVEL_REQUEST:
          /** S02-P012 ペットらくのり申込 */
          this.subHeader = PetEasyTravelRequestSubHeaderComponent;
          break;
        case ServicingFunctionIdType.SERVICE_REQUEST + '-' + ServicingPageIdType.JUNIOR_PILOT_REQUEST:
          /** S02-P013：ジュニアパイロット申込 */
          this.subHeader = JuniorPilotRequestSubHeaderComponent;
          break;
        case ServicingFunctionIdType.SEATMAP + '-' + ServicingPageIdType.SEATMAP:
          /** S03-P010：シートマップ */
          this.subHeader = ServicingSeatmapSubHeaderComponent;
          break;
        case ServicingFunctionIdType.SEATMAP + '-' + ServicingPageIdType.SEAT_ATTRIBUTE_REQUEST:
          /** S03-P020：座席属性指定 */
          this.subHeader = SeatAttributeRequestSubHeaderComponent;
          break;
        case ServicingFunctionIdType.SEATMAP + '-' + ServicingPageIdType.INFORMATIVE_SEATMAP:
          /** S03-P030：シートマップ参照 */
          this.subHeader = InformativeSeatmapSubHeaderComponent;
          break;
        /** KMS追加end */
        default:
          this.subHeader = SampleSubHeaderComponent;
          break;
      }
    });

    // 言語が変更された際にキャッシュをロードする。
    this._aswContextStoreSvc.getAswContext$().subscribe((data) => {
      if (data.lang && this.lang && data.lang !== this.lang) {
        // 利用言語の再設定とキャッシュ再ロード
        this._setLangAndloadCache(data.lang);
      }
      this.lang = data.lang;
    });

    this.routerSubscription = this.router.events.subscribe((event) => {
      //計測タグスクリプトの画面遷移時の処理を実行
      if (event instanceof NavigationEnd && (window as any).trackingTags?.onPageTransition !== undefined) {
        const url = event.urlAfterRedirects;
        const title = document.title;
        (window as any).trackingTags.onPageTransition(url, title);
      }
    });
  }

  /** 利用言語の設定とキャッシュ再ロード */
  private _setLangAndloadCache(langValue?: string) {
    let lang = langValue;
    if (lang) {
      lang = lang in I18N_CONFIG.supportedLocales ? lang : 'ja';
    } else {
      lang = I18N_CONFIG.defaultLanguage;
    }
    this._translateSvc
      .use(lang)
      .pipe(take(1))
      .subscribe(() => {
        // キャッシュ再ロード
        lastValueFrom(this._aswMasterService.load(LOAD_MASTER_LIST));
      });
    // html lang属性再設定
    this._document.documentElement.lang = I18N_CONFIG.supportedLocales[lang];
  }

  ngOnDestroy(): void {
    if (this.subPageSubscription) {
      this.subPageSubscription.unsubscribe();
    }

    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  ngAfterViewInit() {
    this._ngZone.runOutsideAngular(() => {
      this._setDynatraceTag();
    });
  }

  /**
   * Dynatrace用scriptタグを設置
   */
  private _setDynatraceTag() {
    let key: 'res' | 'srv' | 'exc' | 'cki';
    const URL = window.location.href;
    switch (true) {
      case URL.includes(`${environment.spa.baseUrl}${environment.spa.app.res}`):
        key = 'res';
        break;
      case URL.includes(`${environment.spa.baseUrl}${environment.spa.app.srv}`):
        key = 'srv';
        break;
      case URL.includes(`${environment.spa.baseUrl}${environment.spa.app.exc}`):
        key = 'exc';
        break;
      case URL.includes(`${environment.spa.baseUrl}${environment.spa.app.cki}`):
        key = 'cki';
        break;
      default:
        return;
    }

    if (environment.dynatrace[key].disable || !environment.dynatrace[key].url) {
      return;
    }

    const $script: HTMLScriptElement = this._document.createElement('script');
    $script.async = true;
    $script.type = 'text/javascript';
    $script.src = environment.dynatrace[key].url;
    $script.crossOrigin = 'anonymous';
    const $head: HTMLHeadElement = this._document.getElementsByTagName('head')[0];
    if ($head) {
      $head.appendChild($script);
    }
  }

  subPageSubscription?: Subscription;
  public subHeader: any;

  routerSubscription?: Subscription;
}
